// Mobile provides CUSTOMER_NAME, but web provides REACT_APP_CUSTOMER_NAME
export const CUSTOMER_NAME =
  process.env.CUSTOMER_NAME || process.env.REACT_APP_CUSTOMER_NAME
export const isSN = CUSTOMER_NAME === 'sportninja'
export const isCanlan = CUSTOMER_NAME === 'canlan'

// SN-7578: tenants whose admin player-search toggle should remain a TRUE
// global search (no organization_id / account_id scope on the request) rather
// than the account-scoped behavior used for vanilla SportNinja. Add a
// CUSTOMER_NAME here when product approves another white-label tenant for
// global search; tenants not listed default to account-scoped search.
const TRUE_GLOBAL_SEARCH_CUSTOMERS = ['canlan']
export const usesTrueGlobalPlayerSearch =
  TRUE_GLOBAL_SEARCH_CUSTOMERS.includes(CUSTOMER_NAME)
